import { WebViewNoteEditorEvent } from '../../types';
import { parseWebViewEvent } from '../parseWebViewEvent';

export function parseWebViewNoteEditorEvent(
  message: MessageEvent,
): WebViewNoteEditorEvent {
  return (parseWebViewEvent(message) as unknown) as WebViewNoteEditorEvent;
}
